<picture *ngIf="url" class="dummy-img" [class.natural]="natural" (appDeferLoad)="initPicture()">
    <source *ngIf="url.length > 1" media="(max-width: 600px)" [srcset]="url | img:'mobile':'webp'" type="image/webp">
    <source *ngIf="url.length > 1" media="(max-width: 600px)" [srcset]="url | img:'mobile':'normal'">
    <source [srcset]="url | img:'desktop':'webp'" type="image/webp">
    <img [src]="url | img:'desktop':'normal'" [alt]="caption" *ngIf="photo" (load)="loadedPicture()">
</picture>
<span *ngIf="!natural" class="app-image-prop" [style.padding-bottom.%]="proportion"></span>
<span *ngIf="showCaption && natural" class="app-image-caption" [innerHtml]="caption"></span>